export default "__VITE_PUBLIC_ASSET__ab1e2bb0__"